import RecipientInput from "pages/PanelPage/components/selectedAssessment/assessmentInvite/RecipientInput/RecipientInput";

export default RecipientInput;
